import { RESET_PASSWORD_FAILURE, RESET_PASSWORD_REQUEST, RESET_PASSWORD_SUCCESS } from '../constants/resetPassword.constant';
import { AnyIfEmpty } from 'react-redux';
import { Dispatch } from 'redux';
import axios from 'axios';

const resetPasswordRequest = () => {
    return {
        type: RESET_PASSWORD_REQUEST,
    };
};

const resetPasswordSuccess = (data: AnyIfEmpty<object>) => {
    return {
        type: RESET_PASSWORD_SUCCESS,
        payload: data,
    };
};

const resetPasswordFailure = (errMsg: AnyIfEmpty<object>) => {
    return {
        type: RESET_PASSWORD_FAILURE,
        payload: errMsg,
    };
};

export const resetPassword = (resetPasswordDetails: AnyIfEmpty<object>) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(resetPasswordRequest());
        await axios
            .post('/admin/reset-password', resetPasswordDetails)
            .then((response) => {
                dispatch(resetPasswordSuccess(response.data));
            })
            .catch((err) => dispatch(resetPasswordFailure(err)));
    };
};
